export const en = {
    confirm: 'Please confirm action',
    error: 'Error',
};
